// extracted by mini-css-extract-plugin
module.exports = {"configurator":"configurator_configurator__DS7TY"};